import { apiFetch } from '../utils/api';

export interface CustomerVehicle {
  id: string;
  customerId: string | null;
  vehicleBrandId: string | null;
  vehicleModelId: string | null;
  vehicleRegistrationYear: number | null;
  vehicleRegistrationNumber: string;
  vehicleVin: string | null;
  vehicleChassisNumber: string | null;
  fuelType: string | null;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  vehicleBrand?: { id: string; name: string } | null;
  vehicleModel?: { id: string; name: string } | null;
  customer?: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    mobileNumber: string | null;
  } | null;
}

interface FetchCustomerVehiclesParams {
  customerId?: string;
  search?: string;
}

export const fetchCustomerVehicles = (
  params: FetchCustomerVehiclesParams,
): Promise<CustomerVehicle[]> => {
  const searchParams = new URLSearchParams();

  if (params.customerId) {
    searchParams.set('customerId', params.customerId);
  }

  if (params.search) {
    searchParams.set('search', params.search.trim());
  }

  const query = searchParams.toString();
  return apiFetch<CustomerVehicle[]>(
    `/customer-vehicles${query ? `?${query}` : ''}`,
  );
};

interface CustomerVehiclePayload {
  customerId?: string | null;
  vehicleBrandId?: string | null;
  vehicleModelId?: string | null;
  vehicleRegistrationYear?: number | null;
  vehicleRegistrationNumber?: string;
  vehicleVin?: string | null;
  vehicleChassisNumber?: string | null;
  isActive?: boolean;
  fuelType?: string | null;
}

export const createCustomerVehicle = (
  payload: CustomerVehiclePayload & { vehicleRegistrationNumber: string; customerId: string },
): Promise<CustomerVehicle> =>
  apiFetch<CustomerVehicle>('/customer-vehicles', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateCustomerVehicle = (
  id: string,
  payload: CustomerVehiclePayload,
): Promise<CustomerVehicle> =>
  apiFetch<CustomerVehicle>(`/customer-vehicles/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const fetchCustomerVehicle = (id: string): Promise<CustomerVehicle> =>
  apiFetch<CustomerVehicle>(`/customer-vehicles/${id}`);
